__turbopack_context__.v({
  "alignmentContainer": "CommonStyles-module-module__ktiXPa__alignmentContainer",
  "captionContainer": "CommonStyles-module-module__ktiXPa__captionContainer",
  "captionWrapper": "CommonStyles-module-module__ktiXPa__captionWrapper",
});
